/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from '../../$$_gendir/node_modules/ngx-bootstrap/alert/alert.component.ngfactory';
import * as i4 from '../../$$_gendir/node_modules/ngx-bootstrap/typeahead/typeahead-container.component.ngfactory';
import * as i5 from '../../$$_gendir/node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory';
import * as i6 from '../../$$_gendir/node_modules/ngx-bootstrap/tooltip/tooltip-container.component.ngfactory';
import * as i7 from '../../$$_gendir/node_modules/ngx-bootstrap/modal/modal-backdrop.component.ngfactory';
import * as i8 from '../../$$_gendir/node_modules/ngx-bootstrap/modal/modal-container.component.ngfactory';
import * as i9 from './home/home.component.ngfactory';
import * as i10 from './build/build.component.ngfactory';
import * as i11 from './thankyou/thankyou.component.ngfactory';
import * as i12 from './deploy/deploy.component.ngfactory';
import * as i13 from './myaccount/myaccount.component.ngfactory';
import * as i14 from './app.component.ngfactory';
import * as i15 from '@angular/common';
import * as i16 from '@angular/platform-browser';
import * as i17 from '@angular/forms';
import * as i18 from '@angular/http';
import * as i19 from 'angularfire2';
import * as i20 from 'angularfire2/database';
import * as i21 from 'angularfire2/auth';
import * as i22 from '@angular/router';
import * as i23 from 'ngx-bootstrap/alert/alert.config';
import * as i24 from 'ngx-bootstrap/positioning/positioning.service';
import * as i25 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i26 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i27 from 'ngx-bootstrap/tooltip/tooltip.config';
import * as i28 from 'ngx-bootstrap/modal/bs-modal.service';
import * as i29 from '../../app/services/github.service';
import * as i30 from '../../app/services/userdata.service';
import * as i31 from '../../app/services/window.service';
import * as i32 from '../../app/services/auth.service';
import * as i33 from '../../app/nav/nav.component';
import * as i34 from '../../app/services/designs.service';
import * as i35 from '../../app/services/stripe.service';
import * as i36 from '../../app/home/home.component';
import * as i37 from '../../app/build/build.component';
import * as i38 from '../../app/thankyou/thankyou.component';
import * as i39 from '../../app/deploy/deploy.component';
import * as i40 from '../../app/myaccount/myaccount.component';
import * as i41 from 'ngx-bootstrap/alert/alert.module';
import * as i42 from 'ngx-bootstrap/typeahead/typeahead.module';
import * as i43 from 'ngx-bootstrap/dropdown/bs-dropdown.module';
import * as i44 from 'ngx-bootstrap/tooltip/tooltip.module';
import * as i45 from 'ngx-bootstrap/buttons/buttons.module';
import * as i46 from 'ngx-bootstrap/modal/modal.module';
import * as i47 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.AlertComponentNgFactory,i4.TypeaheadContainerComponentNgFactory,
              i5.BsDropdownContainerComponentNgFactory,i6.TooltipContainerComponentNgFactory,
              i7.ModalBackdropComponentNgFactory,i8.ModalContainerComponentNgFactory,
              i9.HomeComponentNgFactory,i10.BuildComponentNgFactory,i11.ThankyouComponentNgFactory,
              i12.DeployComponentNgFactory,i13.MyaccountComponentNgFactory,i14.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i15.NgLocalization,i15.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i16.DomSanitizer,i16.ɵe,[i15.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i16.DomSanitizer]),i0.ɵmpd(4608,
              i16.HAMMER_GESTURE_CONFIG,i16.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i16.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i16.ɵDomEventsPlugin(p0_0),new i16.ɵKeyEventsPlugin(p1_0),
                    new i16.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i15.DOCUMENT,i15.DOCUMENT,i15.DOCUMENT,i16.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i16.EventManager,i16.EventManager,[i16.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i16.ɵDomSharedStylesHost,i16.ɵDomSharedStylesHost,
              [i15.DOCUMENT]),i0.ɵmpd(4608,i16.ɵDomRendererFactory2,i16.ɵDomRendererFactory2,
              [i16.EventManager,i16.ɵDomSharedStylesHost]),i0.ɵmpd(6144,i0.RendererFactory2,
              (null as any),[i16.ɵDomRendererFactory2]),i0.ɵmpd(6144,i16.ɵSharedStylesHost,
              (null as any),[i16.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i0.Testability,
              i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i16.Meta,i16.Meta,[i15.DOCUMENT]),
          i0.ɵmpd(4608,i16.Title,i16.Title,[i15.DOCUMENT]),i0.ɵmpd(4608,i17.ɵi,i17.ɵi,
              ([] as any[])),i0.ɵmpd(4608,i17.FormBuilder,i17.FormBuilder,([] as any[])),
          i0.ɵmpd(4608,i18.BrowserXhr,i18.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i18.ResponseOptions,
              i18.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i18.XSRFStrategy,
              i18.ɵb,([] as any[])),i0.ɵmpd(4608,i18.XHRBackend,i18.XHRBackend,[i18.BrowserXhr,
              i18.ResponseOptions,i18.XSRFStrategy]),i0.ɵmpd(4608,i18.RequestOptions,
              i18.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i18.Http,i18.ɵc,[i18.XHRBackend,
              i18.RequestOptions]),i0.ɵmpd(5120,i19.FirebaseApp,i19.ɵa,[i19.FirebaseAppConfigToken,
              i19.FirebaseAppName]),i0.ɵmpd(5120,i20.AngularFireDatabase,i20._getAngularFireDatabase,
              [i19.FirebaseApp]),i0.ɵmpd(5120,i21.AngularFireAuth,i21._getAngularFireAuth,
              [i19.FirebaseApp]),i0.ɵmpd(5120,i22.ActivatedRoute,i22.ɵf,[i22.Router]),
          i0.ɵmpd(4608,i22.NoPreloading,i22.NoPreloading,([] as any[])),i0.ɵmpd(6144,
              i22.PreloadingStrategy,(null as any),[i22.NoPreloading]),i0.ɵmpd(135680,
              i22.RouterPreloader,i22.RouterPreloader,[i22.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i22.PreloadingStrategy]),i0.ɵmpd(4608,i22.PreloadAllModules,
              i22.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i22.ROUTER_INITIALIZER,
              i22.ɵi,[i22.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i22.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i23.AlertConfig,i23.AlertConfig,
              ([] as any[])),i0.ɵmpd(4608,i24.PositioningService,i24.PositioningService,
              ([] as any[])),i0.ɵmpd(4608,i25.ComponentLoaderFactory,i25.ComponentLoaderFactory,
              [i0.ComponentFactoryResolver,i0.NgZone,i0.Injector,i24.PositioningService,
                  i0.ApplicationRef]),i0.ɵmpd(4608,i26.BsDropdownState,i26.BsDropdownState,
              ([] as any[])),i0.ɵmpd(4608,i27.TooltipConfig,i27.TooltipConfig,([] as any[])),
          i0.ɵmpd(4608,i28.BsModalService,i28.BsModalService,[i25.ComponentLoaderFactory]),
          i0.ɵmpd(4608,i29.GithubService,i29.GithubService,[i18.Http]),i0.ɵmpd(4608,
              i30.UserdataService,i30.UserdataService,[i20.AngularFireDatabase,i21.AngularFireAuth]),
          i0.ɵmpd(4608,i31.WindowRefService,i31.WindowRefService,([] as any[])),i0.ɵmpd(4608,
              i32.AuthService,i32.AuthService,[i21.AngularFireAuth]),i0.ɵmpd(4608,
              i33.NavComponent,i33.NavComponent,[i31.WindowRefService,i32.AuthService,
                  i30.UserdataService,i22.Router]),i0.ɵmpd(4608,i34.DesignService,
              i34.DesignService,[i18.Http,i31.WindowRefService]),i0.ɵmpd(4608,i35.StripeService,
              i35.StripeService,[i18.Http]),i0.ɵmpd(512,i15.CommonModule,i15.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i16.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i22.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i22.ɵg,i22.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i16.ɵc(p0_0,p0_1),i22.ɵh(p1_0)];
              },[[2,i16.NgProbeToken],[2,i0.NgProbeToken],i22.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i16.BrowserModule,i16.BrowserModule,[[3,i16.BrowserModule]]),
          i0.ɵmpd(512,i17.ɵba,i17.ɵba,([] as any[])),i0.ɵmpd(512,i17.FormsModule,i17.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i17.ReactiveFormsModule,i17.ReactiveFormsModule,
              ([] as any[])),i0.ɵmpd(512,i18.HttpModule,i18.HttpModule,([] as any[])),
          i0.ɵmpd(1024,i22.ɵa,i22.ɵd,[[3,i22.Router]]),i0.ɵmpd(512,i22.UrlSerializer,
              i22.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,i22.ChildrenOutletContexts,
              i22.ChildrenOutletContexts,([] as any[])),i0.ɵmpd(256,i22.ROUTER_CONFIGURATION,
              {useHash:false,enableTracing:false},([] as any[])),i0.ɵmpd(1024,i15.LocationStrategy,
              i22.ɵc,[i15.PlatformLocation,[2,i15.APP_BASE_HREF],i22.ROUTER_CONFIGURATION]),
          i0.ɵmpd(512,i15.Location,i15.Location,[i15.LocationStrategy]),i0.ɵmpd(512,
              i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i22.ROUTES,() => {
            return [[{path:'',component:i36.HomeComponent},{path:'build',component:i37.BuildComponent},
                {path:'thankyou',component:i38.ThankyouComponent},{path:'deploy',component:i39.DeployComponent},
                {path:'myaccount',component:i40.MyaccountComponent},{path:'**',redirectTo:'home'}]];
          },([] as any[])),i0.ɵmpd(1024,i22.Router,i22.ɵe,[i0.ApplicationRef,i22.UrlSerializer,
              i22.ChildrenOutletContexts,i15.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i22.ROUTES,i22.ROUTER_CONFIGURATION,[2,i22.UrlHandlingStrategy],
              [2,i22.RouteReuseStrategy]]),i0.ɵmpd(512,i22.RouterModule,i22.RouterModule,
              [[2,i22.ɵa],[2,i22.Router]]),i0.ɵmpd(512,i41.AlertModule,i41.AlertModule,
              ([] as any[])),i0.ɵmpd(512,i42.TypeaheadModule,i42.TypeaheadModule,([] as any[])),
          i0.ɵmpd(512,i43.BsDropdownModule,i43.BsDropdownModule,([] as any[])),i0.ɵmpd(512,
              i44.TooltipModule,i44.TooltipModule,([] as any[])),i0.ɵmpd(512,i45.ButtonsModule,
              i45.ButtonsModule,([] as any[])),i0.ɵmpd(512,i46.ModalModule,i46.ModalModule,
              ([] as any[])),i0.ɵmpd(512,i19.AngularFireModule,i19.AngularFireModule,
              ([] as any[])),i0.ɵmpd(512,i20.AngularFireDatabaseModule,i20.AngularFireDatabaseModule,
              ([] as any[])),i0.ɵmpd(512,i21.AngularFireAuthModule,i21.AngularFireAuthModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[])),
          i0.ɵmpd(256,i19.FirebaseAppConfigToken,{apiKey:'AIzaSyDDFAzApsKvTSEqvrpGiD9U2TtRalrz5qc',
              authDomain:'devportfolio-ccca6.firebaseapp.com',databaseURL:'https://devportfolio-ccca6.firebaseio.com',
              projectId:'devportfolio-ccca6',storageBucket:'devportfolio-ccca6.appspot.com',
              messagingSenderId:'865260696268'},([] as any[])),i0.ɵmpd(256,i19.FirebaseAppName,
              'angular-auth-firebase',([] as any[])),i0.ɵmpd(256,i47.BsDropdownConfig,
              {autoClose:true},([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL0NocmlzL0RvY3VtZW50cy9XZWJEZXYvRGV2R2VuQW5nL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9DaHJpcy9Eb2N1bWVudHMvV2ViRGV2L0RldkdlbkFuZy9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.module.ngfactory.ts